import styles from "../../styles/system-settings.module.scss";
import { Title } from "../../shared/components/Title";
import { Icon } from "../../shared/components/core/Icon";
import { EnvironmentStorage } from "../../shared/tools/EnvironmentStorage";
import {
  SystemDrawerTypes,
  SystemSettingDrawer,
} from "../../shared/containers/Settings/SystemSettingDrawer";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ForEach } from "../../shared/components/control-statements/ForEach";
import ROLES from "data/Roles";
import { UserStorage } from "shared/tools/UserStorage";

const SettingItem = ({ setting, onClick }) => {
  if (!setting.show) return;

  return (
    <Link to={setting.visible !== false && setting.path}>
      <div
        className={styles.setting}
        onClick={() => setting.show && setting.alias && onClick(setting.alias)}
      >
        <div className={styles.icon}>{setting.icon}</div>
        <p>{setting.name}</p>
      </div>
    </Link>
  );
};

const SettingGroup = ({ group, onClickButton }) => {
  return (
    <div>
      {group.name && (
        <div className={styles.header}>
          <p>
            {group.name} ({group.items.length})
          </p>
        </div>
      )}

      <div className={styles.settings}>
        <ForEach
          items={group.items}
          render={(setting) => {
            return <SettingItem setting={setting} onClick={onClickButton} />;
          }}
        />
      </div>
    </div>
  );
};

export default function SecuritySettings() {
  const environment = EnvironmentStorage.getEnvironment();
  const [showDrawer, setShowDrawer] = useState(false);
  const [holdingId, setHoldingId] = useState(null);

  let userRole = UserStorage.getLoggedUser()?.role;

  const loadEnvironment = async () => {
    setHoldingId(await EnvironmentStorage.getEnvironmentHoldingId());
  };

  useEffect(() => {
    loadEnvironment();
  }, []);

  const isCiaTC = holdingId === 811;

  const settingGroups = [
    {
      items: [
        {
          name: "Clientes bloqueados",
          show: true,
          icon: <Icon name="map" />,
          alias: SystemDrawerTypes.BLOCKED_CUSTOMERS,
        },
        {
          name: "Limite por produto",
          show: environment.type != "BRAND",
          icon: <Icon name="book-open" />,
          alias: SystemDrawerTypes.BLOCK_PRODUCT_SKU,
        },
        {
          name: "Intervalo entre pedidos",
          show: environment.type != "BRAND",
          icon: <Icon name="clock" />,
          alias: SystemDrawerTypes.BLOCK_ORDER_INTERVAL,
        },
      ],
    },
  ];

  const getSubtitle = () => {
    if (environment?.brand)
      return (
        `${environment.brand.name} - ${environment.name}` +
        (environment.active === false ? " (Inativa)" : "")
      );
    return environment?.name;
  };

  return (
    <div className={styles.systemContainer}>
      <Title
        title="Configurações de segurança"
        subtitle={getSubtitle()}
        backTo={{ url: "/configuracoes", name: "Configurações" }}
      />
      <ForEach
        items={settingGroups}
        render={(group, index) => {
          return (
            <SettingGroup
              group={group}
              onClickButton={(drawer) => setShowDrawer(drawer)}
            />
          );
        }}
      />
      {showDrawer && (
        <SystemSettingDrawer
          visible={showDrawer}
          setting={showDrawer}
          onClose={() => setShowDrawer(false)}
          onSave={() => setShowDrawer(false)}
        />
      )}
    </div>
  );
}
